import React, { useRef, useState } from 'react';
import ENUMS from '../../../enums';

import ShowForPermission from '../../../components/ShowForPermission';

const ReserveRequestsListFilter = props => {
  let formRefrence = useRef();
  let [cafeNamePart, setCafeNamePart] = useState();

  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setCafeNamePart('');
    props.applyFilters(event);
  };

  return (
    <article>
      <form
        ref={formRefrence}
        onReset={event => resetForm(event)}
        onSubmit={event => props.applyFilters(event)}
        id="filterForm"
        className="card card my-4"
      >
        <header className="text-center card-header">
          <h5 className="font-italic text-muted">{locales('titles.filter')}</h5>
        </header>
        <main className="card-body">
          <div className="d-flex justidy-content-between px-1">
            <ShowForPermission
              permission={ENUMS.PERMISSIONS.values.VIEW_REQUESTS_RESERVES_FOR_ADMIN}
            >
              <div className="d-flex flex-column col-4 mx-1 h-50 py-2">
                <input
                  onChange={event => setCafeNamePart(event.target.value)}
                  value={cafeNamePart || ''}
                  name="cafeNamePart"
                  type="text"
                  className="form-control col-12"
                  placeholder={locales('fields.cafe.name')}
                  maxLength={ENUMS.MAX_LENGTH.cafeName}
                />
                <small style={{ color: '#ccc' }}>{locales('maxLength.30')}</small>
              </div>
            </ShowForPermission>
          </div>

          <div className="col-12 d-flex justify-content-end p-0">
            <input
              name="resetButton"
              type="reset"
              value={locales('fields.reset')}
              className="btn btn-danger w-5 mx-2"
            />

            <button
              type="submit"
              id="apply-filter-btn-incomingReservation"
              className="btn btn-success w-5 mx-2"
            >
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </article>
  );
};

export default ReserveRequestsListFilter;
